var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAzureDevops(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60.72,
    height: 60.719,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .a{fill:#0078d7}\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.152 14.459L0 22.495v17.187l6.152 1.143zM45.874 13.764v46.931l14.845-12.24v-37.4z",
    className: "a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 22.495l45.874-8.731L27.019 0v6.3L6.152 14.459zM6.153 40.825l54.567 7.63-14.845 12.24-22.883-7.645v7.67z",
    className: "a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureDevops);
export default __webpack_public_path__ + "static/media/azure-devops.02ae28ee49aa1fbe674102d8de8095eb.svg";
export { ForwardRef as ReactComponent };